import { useLanguage } from '@infra/i18n';

/**
 * Whether any language picker should render at all. Single source for the rule,
 * so the header pill, the drawer section and the overflow rows cannot disagree —
 * a drawer heading sitting above nothing is what happens when they do.
 *
 * One entry means no choice to offer. The list is already narrowed to what the
 * account may use, so the entitlement decides this on its own.
 */
export function useLanguagePickerVisible(): boolean {
  const { availableLanguages } = useLanguage();
  return availableLanguages.length >= 2;
}
